// mapping of valueIds to colour hexValues
// used in middleware to augment the responses

export const colourToHexValueMap = {
	SeluxGraphite: '#555',
	BlackMattTiger059: '#333',
	SandMat: '#C6C0A8',
	ClayMat: '#A09576',
	ConcreteGrayMat: '#999',
	JetBlackRAL9005: '#0A0A0A',
	AnthraciteGreyRAL7016: '#293133',
	GraphiteGreyRAL7024: '#474A51',
	IronGreyRAL7011: '#434B4D',
	GreyAluminiumRAL9007: '#8F8F8F',
	WhiteAluminiumRAL9006: '#A5A5A5',
	PureWhiteRAL9010: '#fff',
	TrafficWhiteRAL9016: '#F6F6F6',
	PineGreenRAL6009: '#31372B',
	MossGreenRAL6005: '#2F4538',
	SapphireBlueRAL5003: '#1D1E33',
	WineRedRAL3005: '#5E2129',
	PearledDarkGreyDB703: '#575556',
	PearledSilverGreyDB702: '#777',
	WhiteAluminiumPerlDB701: '#A5A5A5',
	Custom: 'custom',
	StandardColourOfChoice: 'StandardColourOfChoice',
	Gold: '#f1c680',
	Silver: '#e1eef6',
	Black: '#000000',
	Liverpool: '#9A836D',
	Sanssouci: '#A39C8A',
	Versaille: '#C6BAB1',

	'RAL1000/60': '#BEBD7F',
	'RAL1001/60': '#C2B078',
	'RAL1002/60': '#C6A664',
	'RAL1003/60': '#E5BE01',
	'RAL1004/60': '#CDA434',
	'RAL1005/60': '#A98307',
	'RAL1006/60': '#E4A010',
	'RAL1007/60': '#DC9D00',
	'RAL1011/60': '#8A6642',
	'RAL1012/60': '#C7B446',
	'RAL1013/60': '#EAE6CA',
	'RAL1014/60': '#E1CC4F',
	'RAL1015/60': '#E6D690',
	'RAL1016/60': '#EDFF21',
	'RAL1017/60': '#F5D033',
	'RAL1018/60': '#F8F32B',
	'RAL1019/60': '#9E9764',
	'RAL1020/60': '#999950',
	'RAL1021/60': '#F3DA0B',
	'RAL1023/60': '#FAD201',
	'RAL1024/60': '#AEA04B',
	'RAL1026/60': '#FFFF00',
	'RAL1027/60': '#9D9101',
	'RAL1028/60': '#F4A900',
	'RAL1032/60': '#D6AE01',
	'RAL1033/60': '#F3A505',
	'RAL1034/60': '#EFA94A',
	'RAL1035/60': '#6A5D4D',
	'RAL1036/60': '#705335',
	'RAL1037/60': '#F39F18',
	'RAL2000/60': '#ED760E',
	'RAL2001/60': '#C93C20',
	'RAL2002/60': '#CB2821',
	'RAL2003/60': '#FF7514',
	'RAL2004/60': '#F44611',
	'RAL2005/60': '#FF2301',
	'RAL2007/60': '#FFA420',
	'RAL2008/60': '#F75E25',
	'RAL2009/60': '#F54021',
	'RAL2010/60': '#D84B20',
	'RAL2011/60': '#EC7C26',
	'RAL2012/60': '#E55137',
	'RAL2013/60': '#C35831',
	'RAL3000/60': '#AF2B1E',
	'RAL3001/60': '#A52019',
	'RAL3002/60': '#A2231D',
	'RAL3003/60': '#9B111E',
	'RAL3004/60': '#75151E',
	'RAL3005/60': '#5E2129',
	'RAL3007/60': '#412227',
	'RAL3009/60': '#642424',
	'RAL3011/60': '#781F19',
	'RAL3012/60': '#C1876B',
	'RAL3013/60': '#A12312',
	'RAL3014/60': '#D36E70',
	'RAL3015/60': '#EA899A',
	'RAL3016/60': '#B32821',
	'RAL3017/60': '#E63244',
	'RAL3018/60': '#D53032',
	'RAL3020/60': '#CC0605',
	'RAL3022/60': '#D95030',
	'RAL3024/60': '#F80000',
	'RAL3026/60': '#FE0000',
	'RAL3027/60': '#C51D34',
	'RAL3028/60': '#CB3234',
	'RAL3031/60': '#B32428',
	'RAL3032/60': '#721422',
	'RAL3033/60': '#B44C43',
	'RAL4001/60': '#6D3F5B',
	'RAL4002/60': '#922B3E',
	'RAL4003/60': '#DE4C8A',
	'RAL4004/60': '#641C34',
	'RAL4005/60': '#6C4675',
	'RAL4006/60': '#A03472',
	'RAL4007/60': '#4A192C',
	'RAL4008/60': '#924E7D',
	'RAL4009/60': '#A18594',
	'RAL4010/60': '#CF3476',
	'RAL4011/60': '#8673A1',
	'RAL4012/60': '#6C6874',
	'RAL5000/60': '#354D73',
	'RAL5001/60': '#1F3438',
	'RAL5002/60': '#20214F',
	'RAL5003/60': '#1D1E33',
	'RAL5004/60': '#18171C',
	'RAL5005/60': '#1E2460',
	'RAL5007/60': '#3E5F8A',
	'RAL5008/60': '#26252D',
	'RAL5009/60': '#025669',
	'RAL5010/60': '#0E294B',
	'RAL5011/60': '#231A24',
	'RAL5012/60': '#3B83BD',
	'RAL5013/60': '#1E213D',
	'RAL5014/60': '#606E8C',
	'RAL5015/60': '#2271B3',
	'RAL5017/60': '#063971',
	'RAL5018/60': '#3F888F',
	'RAL5019/60': '#1B5583',
	'RAL5020/60': '#1D334A',
	'RAL5021/60': '#256D7B',
	'RAL5022/60': '#252850',
	'RAL5023/60': '#49678D',
	'RAL5024/60': '#5D9B9B',
	'RAL5025/60': '#2A6478',
	'RAL5026/60': '#102C54',
	'RAL6000/60': '#316650',
	'RAL6001/60': '#287233',
	'RAL6002/60': '#2D572C',
	'RAL6003/60': '#424632',
	'RAL6004/60': '#1F3A3D',
	'RAL6005/60': '#2F4538',
	'RAL6006/60': '#3E3B32',
	'RAL6007/60': '#343B29',
	'RAL6008/60': '#39352A',
	'RAL6009/60': '#31372B',
	'RAL6010/60': '#35682D',
	'RAL6011/60': '#587246',
	'RAL6012/60': '#343E40',
	'RAL6013/60': '#6C7156',
	'RAL6014/60': '#47402E',
	'RAL6015/60': '#3B3C36',
	'RAL6016/60': '#1E5945',
	'RAL6017/60': '#4C9141',
	'RAL6018/60': '#57A639',
	'RAL6019/60': '#BDECB6',
	'RAL6020/60': '#2E3A23',
	'RAL6021/60': '#89AC76',
	'RAL6022/60': '#25221B',
	'RAL6024/60': '#308446',
	'RAL6025/60': '#3D642D',
	'RAL6026/60': '#015D52',
	'RAL6027/60': '#84C3BE',
	'RAL6028/60': '#2C5545',
	'RAL6029/60': '#20603D',
	'RAL6032/60': '#317F43',
	'RAL6033/60': '#497E76',
	'RAL6034/60': '#7FB5B5',
	'RAL6035/60': '#1C542D',
	'RAL6036/60': '#193737',
	'RAL6037/60': '#008F39',
	'RAL6038/60': '#00BB2D',
	'RAL7000/60': '#78858B',
	'RAL7001/60': '#8A9597',
	'RAL7002/60': '#7E7B52',
	'RAL7003/60': '#6C7059',
	'RAL7004/60': '#969992',
	'RAL7005/60': '#646B63',
	'RAL7006/60': '#6D6552',
	'RAL7008/60': '#6A5F31',
	'RAL7009/60': '#4D5645',
	'RAL7010/60': '#4C514A',
	'RAL7011/60': '#434B4D',
	'RAL7012/60': '#4E5754',
	'RAL7013/60': '#464531',
	'RAL7015/60': '#434750',
	'RAL7016/60': '#293133',
	'RAL7021/60': '#23282B',
	'RAL7022/60': '#332F2C',
	'RAL7023/60': '#686C5E',
	'RAL7024/60': '#474A51',
	'RAL7026/60': '#2F353B',
	'RAL7030/60': '#8B8C7A',
	'RAL7031/60': '#474B4E',
	'RAL7032/60': '#B8B799',
	'RAL7033/60': '#7D8471',
	'RAL7034/60': '#8F8B66',
	'RAL7035/60': '#D7D7D7',
	'RAL7036/60': '#7F7679',
	'RAL7037/60': '#7D7F7D',
	'RAL7038/60': '#B5B8B1',
	'RAL7039/60': '#6C6960',
	'RAL7040/60': '#9DA1AA',
	'RAL7042/60': '#8D948D',
	'RAL7043/60': '#4E5452',
	'RAL7044/60': '#CAC4B0',
	'RAL7045/60': '#909090',
	'RAL7046/60': '#82898F',
	'RAL7047/60': '#D0D0D0',
	'RAL7048/60': '#898176',
	'RAL8000/60': '#826C34',
	'RAL8001/60': '#955F20',
	'RAL8002/60': '#6C3B2A',
	'RAL8003/60': '#734222',
	'RAL8004/60': '#8E402A',
	'RAL8007/60': '#59351F',
	'RAL8008/60': '#6F4F28',
	'RAL8011/60': '#5B3A29',
	'RAL8012/60': '#592321',
	'RAL8014/60': '#382C1E',
	'RAL8015/60': '#633A34',
	'RAL8016/60': '#4C2F27',
	'RAL8017/60': '#45322E',
	'RAL8019/60': '#403A3A',
	'RAL8022/60': '#212121',
	'RAL8023/60': '#A65E2E',
	'RAL8024/60': '#79553D',
	'RAL8025/60': '#755C48',
	'RAL8028/60': '#4E3B31',
	'RAL8029/60': '#763C28',
	'RAL9001/60': '#FDF4E3',
	'RAL9002/60': '#E7EBDA',
	'RAL9003/60': '#F4F4F4',
	'RAL9004/60': '#282828',
	'RAL9005/60': '#0A0A0A',
	'RAL9006/60': '#A5A5A5',
	'RAL9007/60': '#8F8F8F',
	'RAL9010/60': '#FFFFFF',
	'RAL9011/60': '#1C1C1C',
	'RAL9016/60': '#F6F6F6',
	'RAL9017/60': '#1E1E1E',
	'RAL9018/60': '#D7D7D7',
	'RAL9022/60': '#9C9C9C',
	'RAL9023/60': '#828282',

	'RAL1000/30': '#BEBD7F',
	'RAL1001/30': '#C2B078',
	'RAL1002/30': '#C6A664',
	'RAL1003/30': '#E5BE01',
	'RAL1004/30': '#CDA434',
	'RAL1005/30': '#A98307',
	'RAL1006/30': '#E4A010',
	'RAL1007/30': '#DC9D00',
	'RAL1011/30': '#8A6642',
	'RAL1012/30': '#C7B446',
	'RAL1013/30': '#EAE6CA',
	'RAL1014/30': '#E1CC4F',
	'RAL1015/30': '#E6D690',
	'RAL1016/30': '#EDFF21',
	'RAL1017/30': '#F5D033',
	'RAL1018/30': '#F8F32B',
	'RAL1019/30': '#9E9764',
	'RAL1020/30': '#999950',
	'RAL1021/30': '#F3DA0B',
	'RAL1023/30': '#FAD201',
	'RAL1024/30': '#AEA04B',
	'RAL1026/30': '#FFFF00',
	'RAL1027/30': '#9D9101',
	'RAL1028/30': '#F4A900',
	'RAL1032/30': '#D6AE01',
	'RAL1033/30': '#F3A505',
	'RAL1034/30': '#EFA94A',
	'RAL1035/30': '#6A5D4D',
	'RAL1036/30': '#705335',
	'RAL1037/30': '#F39F18',
	'RAL2000/30': '#ED760E',
	'RAL2001/30': '#C93C20',
	'RAL2002/30': '#CB2821',
	'RAL2003/30': '#FF7514',
	'RAL2004/30': '#F44611',
	'RAL2005/30': '#FF2301',
	'RAL2007/30': '#FFA420',
	'RAL2008/30': '#F75E25',
	'RAL2009/30': '#F54021',
	'RAL2010/30': '#D84B20',
	'RAL2011/30': '#EC7C26',
	'RAL2012/30': '#E55137',
	'RAL2013/30': '#C35831',
	'RAL3000/30': '#AF2B1E',
	'RAL3001/30': '#A52019',
	'RAL3002/30': '#A2231D',
	'RAL3003/30': '#9B111E',
	'RAL3004/30': '#75151E',
	'RAL3005/30': '#5E2129',
	'RAL3007/30': '#412227',
	'RAL3009/30': '#642424',
	'RAL3011/30': '#781F19',
	'RAL3012/30': '#C1876B',
	'RAL3013/30': '#A12312',
	'RAL3014/30': '#D36E70',
	'RAL3015/30': '#EA899A',
	'RAL3016/30': '#B32821',
	'RAL3017/30': '#E63244',
	'RAL3018/30': '#D53032',
	'RAL3020/30': '#CC0605',
	'RAL3022/30': '#D95030',
	'RAL3024/30': '#F80000',
	'RAL3026/30': '#FE0000',
	'RAL3027/30': '#C51D34',
	'RAL3028/30': '#CB3234',
	'RAL3031/30': '#B32428',
	'RAL3032/30': '#721422',
	'RAL3033/30': '#B44C43',
	'RAL4001/30': '#6D3F5B',
	'RAL4002/30': '#922B3E',
	'RAL4003/30': '#DE4C8A',
	'RAL4004/30': '#641C34',
	'RAL4005/30': '#6C4675',
	'RAL4006/30': '#A03472',
	'RAL4007/30': '#4A192C',
	'RAL4008/30': '#924E7D',
	'RAL4009/30': '#A18594',
	'RAL4010/30': '#CF3476',
	'RAL4011/30': '#8673A1',
	'RAL4012/30': '#6C6874',
	'RAL5000/30': '#354D73',
	'RAL5001/30': '#1F3438',
	'RAL5002/30': '#20214F',
	'RAL5003/30': '#1D1E33',
	'RAL5004/30': '#18171C',
	'RAL5005/30': '#1E2460',
	'RAL5007/30': '#3E5F8A',
	'RAL5008/30': '#26252D',
	'RAL5009/30': '#025669',
	'RAL5010/30': '#0E294B',
	'RAL5011/30': '#231A24',
	'RAL5012/30': '#3B83BD',
	'RAL5013/30': '#1E213D',
	'RAL5014/30': '#606E8C',
	'RAL5015/30': '#2271B3',
	'RAL5017/30': '#063971',
	'RAL5018/30': '#3F888F',
	'RAL5019/30': '#1B5583',
	'RAL5020/30': '#1D334A',
	'RAL5021/30': '#256D7B',
	'RAL5022/30': '#252850',
	'RAL5023/30': '#49678D',
	'RAL5024/30': '#5D9B9B',
	'RAL5025/30': '#2A6478',
	'RAL5026/30': '#102C54',
	'RAL6000/30': '#316650',
	'RAL6001/30': '#287233',
	'RAL6002/30': '#2D572C',
	'RAL6003/30': '#424632',
	'RAL6004/30': '#1F3A3D',
	'RAL6005/30': '#2F4538',
	'RAL6006/30': '#3E3B32',
	'RAL6007/30': '#343B29',
	'RAL6008/30': '#39352A',
	'RAL6009/30': '#31372B',
	'RAL6010/30': '#35682D',
	'RAL6011/30': '#587246',
	'RAL6012/30': '#343E40',
	'RAL6013/30': '#6C7156',
	'RAL6014/30': '#47402E',
	'RAL6015/30': '#3B3C36',
	'RAL6016/30': '#1E5945',
	'RAL6017/30': '#4C9141',
	'RAL6018/30': '#57A639',
	'RAL6019/30': '#BDECB6',
	'RAL6020/30': '#2E3A23',
	'RAL6021/30': '#89AC76',
	'RAL6022/30': '#25221B',
	'RAL6024/30': '#308446',
	'RAL6025/30': '#3D642D',
	'RAL6026/30': '#015D52',
	'RAL6027/30': '#84C3BE',
	'RAL6028/30': '#2C5545',
	'RAL6029/30': '#20603D',
	'RAL6032/30': '#317F43',
	'RAL6033/30': '#497E76',
	'RAL6034/30': '#7FB5B5',
	'RAL6035/30': '#1C542D',
	'RAL6036/30': '#193737',
	'RAL6037/30': '#008F39',
	'RAL6038/30': '#00BB2D',
	'RAL7000/30': '#78858B',
	'RAL7001/30': '#8A9597',
	'RAL7002/30': '#7E7B52',
	'RAL7003/30': '#6C7059',
	'RAL7004/30': '#969992',
	'RAL7005/30': '#646B63',
	'RAL7006/30': '#6D6552',
	'RAL7008/30': '#6A5F31',
	'RAL7009/30': '#4D5645',
	'RAL7010/30': '#4C514A',
	'RAL7011/30': '#434B4D',
	'RAL7012/30': '#4E5754',
	'RAL7013/30': '#464531',
	'RAL7015/30': '#434750',
	'RAL7016/30': '#293133',
	'RAL7021/30': '#23282B',
	'RAL7022/30': '#332F2C',
	'RAL7023/30': '#686C5E',
	'RAL7024/30': '#474A51',
	'RAL7026/30': '#2F353B',
	'RAL7030/30': '#8B8C7A',
	'RAL7031/30': '#474B4E',
	'RAL7032/30': '#B8B799',
	'RAL7033/30': '#7D8471',
	'RAL7034/30': '#8F8B66',
	'RAL7035/30': '#D7D7D7',
	'RAL7036/30': '#7F7679',
	'RAL7037/30': '#7D7F7D',
	'RAL7038/30': '#B5B8B1',
	'RAL7039/30': '#6C6960',
	'RAL7040/30': '#9DA1AA',
	'RAL7042/30': '#8D948D',
	'RAL7043/30': '#4E5452',
	'RAL7044/30': '#CAC4B0',
	'RAL7045/30': '#909090',
	'RAL7046/30': '#82898F',
	'RAL7047/30': '#D0D0D0',
	'RAL7048/30': '#898176',
	'RAL8000/30': '#826C34',
	'RAL8001/30': '#955F20',
	'RAL8002/30': '#6C3B2A',
	'RAL8003/30': '#734222',
	'RAL8004/30': '#8E402A',
	'RAL8007/30': '#59351F',
	'RAL8008/30': '#6F4F28',
	'RAL8011/30': '#5B3A29',
	'RAL8012/30': '#592321',
	'RAL8014/30': '#382C1E',
	'RAL8015/30': '#633A34',
	'RAL8016/30': '#4C2F27',
	'RAL8017/30': '#45322E',
	'RAL8019/30': '#403A3A',
	'RAL8022/30': '#212121',
	'RAL8023/30': '#A65E2E',
	'RAL8024/30': '#79553D',
	'RAL8025/30': '#755C48',
	'RAL8028/30': '#4E3B31',
	'RAL8029/30': '#763C28',
	'RAL9001/30': '#FDF4E3',
	'RAL9002/30': '#E7EBDA',
	'RAL9003/30': '#F4F4F4',
	'RAL9004/30': '#282828',
	'RAL9005/30': '#0A0A0A',
	'RAL9006/30': '#A5A5A5',
	'RAL9007/30': '#8F8F8F',
	'RAL9010/30': '#FFFFFF',
	'RAL9011/30': '#1C1C1C',
	'RAL9016/30': '#F6F6F6',
	'RAL9017/30': '#1E1E1E',
	'RAL9018/30': '#D7D7D7',
	'RAL9022/30': '#9C9C9C',
	'RAL9023/30': '#828282',
};
